import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../../reducers';
import { removeFilesFromImport } from '../../../../containers/ImportManager/actions';
import {
	StyledHeader,
	Title,
	ErrorBadge,
	Toggle,
	ButtonClose,
} from '../styles';
import Utils from '../../../../utils';

interface HeaderProps {
	filesIds: string[];
	importedFilesNumber: number;
	isFilesWithError: boolean;
	isToastExpanded: boolean;
	onToggle: () => void;
	dispatch: Dispatch<StoreState>;
}

const Header = ({
	filesIds,
	importedFilesNumber,
	isFilesWithError,
	isToastExpanded,
	onToggle,
	dispatch,
}: HeaderProps) => {
	const handleClose = () => {
		dispatch(removeFilesFromImport(filesIds));
	};

	const isAllFilesImported = filesIds.length === importedFilesNumber;
	const title = isAllFilesImported
		? 'messages.imported_all_files'
		: 'messages.importing_files_status';

	return (
		<StyledHeader>
			<Title
				value={title}
				importedFiles={importedFilesNumber}
				totalFiles={filesIds.length}
			/>
			{isFilesWithError && <ErrorBadge />}
			<Toggle
				type="button"
				isExpanded={isToastExpanded}
				onClick={onToggle}
			>
				{Utils.getSvgIcon('iconset_down')}
			</Toggle>
			<ButtonClose
				type="button"
				onClick={handleClose}
			>
				{Utils.getSvgIcon('iconset_close-2')}
			</ButtonClose>
		</StyledHeader>
	);
};

export default Header;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImportDesktopFile/Toast/Header/index.tsx